import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const jsona = new Jsona();

const EXTERNAL_USER_API = `${API_URL}/backoffice/externalusers/registrationdata`;
const INTERNAL_USER_API = `${API_URL}/backoffice/registrationdata`

async function getAll(params) {
  const response = await axios.get(EXTERNAL_USER_API, { params: params, headers: authHeader() });
  return response.data;
}


async function get(id, byEmail) {
  const response = await axios.get(EXTERNAL_USER_API + '/' + id + '?by_email=' + byEmail, { headers: authHeader() });
  return response.data;
}


async function create(params) {
  const response = await axios.post(EXTERNAL_USER_API, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function update(params, id) {
  const response = await axios.put(EXTERNAL_USER_API + "/" + id, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function deleteAction(id) {
  const response = await axios.delete(EXTERNAL_USER_API + '/' + id, { headers: authHeader() });
  return response.data;
}

async function getAllInternal(params) {
  const response = await axios.get(INTERNAL_USER_API, { params: params, headers: authHeader() });
  return response.data;
}

async function getInternal(id) {
  const response = await axios.get(INTERNAL_USER_API + '/' + id, { headers: authHeader() });
  return response.data;
}

async function createInternal(params) {
  const response = await axios.post(INTERNAL_USER_API, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function updateInternal(params, id) {
  const response = await axios.put(INTERNAL_USER_API + "/" + id, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function deleteInternal(id) {
  const response = await axios.delete(INTERNAL_USER_API + '/' + id, { headers: authHeader() });
  return response.data;
}

async function updateActivation(isActive, id) {
  const activationType = isActive ? 'activate' : 'deactivate'
  const response = await axios.put(EXTERNAL_USER_API + "/" + id + "/" + activationType, {}, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

export default {
  getAll,
  update,
  get,
  create,
  delete: deleteAction,
  getAllInternal,
  createInternal,
  updateInternal,
  getInternal,
  deleteInternal,
  updateActivation
};